export default __webpack_public_path__ + "static/media/featSportBg.4131f056.png";